"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuntimeError = exports.NotSupportedError = exports.NotImplementedError = exports.NoAckError = exports.DuplicateCorrelationError = exports.UnexpectedActionError = exports.DisconnectedError = void 0;
class DisconnectedError extends Error {
    constructor(readyState) {
        super(`Expected websocket state OPEN but found ${readyState}`);
        this.readyState = readyState;
    }
}
exports.DisconnectedError = DisconnectedError;
class UnexpectedActionError extends Error {
}
exports.UnexpectedActionError = UnexpectedActionError;
class DuplicateCorrelationError extends Error {
}
exports.DuplicateCorrelationError = DuplicateCorrelationError;
class NoAckError extends Error {
}
exports.NoAckError = NoAckError;
class NotImplementedError extends Error {
}
exports.NotImplementedError = NotImplementedError;
class NotSupportedError extends Error {
}
exports.NotSupportedError = NotSupportedError;
class InternalError extends Error {
    constructor(err) {
        const { message, name, stack, ...rest } = err;
        super(message);
        this.name = name || 'Error';
        this.stack = stack !== null && stack !== void 0 ? stack : this.toString();
        Object.keys(rest).forEach(key => {
            this[key] = rest[key];
        });
    }
}
// For documentation of the error methods being used see here: https://v8.dev/docs/stack-trace-api
class RuntimeError extends Error {
    static getCallSite(callsToRemove = 0) {
        var _a, _b;
        const length = Error.stackTraceLimit;
        const realCallsToRemove = callsToRemove + 1; // remove this call;
        Error.stackTraceLimit = length + realCallsToRemove;
        // eslint-disable-next-line no-underscore-dangle
        const _prepareStackTrace = Error.prepareStackTrace;
        // This will be called when we access the `stack` property
        Error.prepareStackTrace = (_, stack) => stack;
        // stack is optional in non chromium contexts
        const stack = (_b = (_a = new Error().stack) === null || _a === void 0 ? void 0 : _a.slice(realCallsToRemove)) !== null && _b !== void 0 ? _b : [];
        Error.prepareStackTrace = _prepareStackTrace;
        Error.stackTraceLimit = length;
        return stack;
    }
    static prepareStackTrace(err, callSites) {
        if (typeof Error.prepareStackTrace === 'function') {
            return Error.prepareStackTrace(err, callSites);
        }
        let string = "";
        string += err.name || "Error";
        string += `: ${err.message || ""}`;
        for (const callSite of callSites) {
            string += `\n    at ${callSite.toString()}`;
        }
        return string;
    }
    ;
    constructor(payload, callSites) {
        const { reason, error } = payload;
        super(reason);
        this.name = 'RuntimeError';
        if (error === null || error === void 0 ? void 0 : error.stack) {
            this.cause = new InternalError(error);
        }
        if (callSites) {
            this.stack = RuntimeError.prepareStackTrace(this, callSites);
        }
    }
}
exports.RuntimeError = RuntimeError;
